<template>
    <div class="flex items-center justify-center h-screen bg-white">
        <div class="animate-pulse">
            <div
                class="size-12 flex items-center justify-center bg-primary-500 rounded-lg"
            >
                <FdxIconAccountBalance class="size-8 text-white" />
            </div>
        </div>
    </div>
</template>
